import { useMutation, useQueryClient } from '@tanstack/react-query';
import toast from 'react-hot-toast';
import { folderService } from '../services/folderService';

export function useBulkActions() {
  const queryClient = useQueryClient();
  const invalidate = () => queryClient.invalidateQueries({ queryKey: ['items'] });

  const { mutateAsync: bulkDelete } = useMutation({
    mutationFn: (selectedIds) => folderService.bulkDeleteItems([...selectedIds]),
    onSuccess: (data) => {
      invalidate();
      toast.success(`${data.deleted} item${data.deleted === 1 ? '' : 's'} moved to trash`);
    },
    onError: () => toast.error('Failed to delete items'),
  });

  const { mutateAsync: bulkMove } = useMutation({
    mutationFn: ({ selectedIds, targetFolderId }) =>
      folderService.bulkMoveItems([...selectedIds], targetFolderId),
    onSuccess: (data) => {
      invalidate();
      toast.success(`${data.moved} item${data.moved === 1 ? '' : 's'} moved`);
    },
    onError: () => toast.error('Failed to move items'),
  });

  return { bulkDelete, bulkMove };
}
